import { createFileRoute, Outlet, redirect, useMatches } from "@tanstack/react-router";
import { ApplicationShell } from "@/components/ApplicationShell";
import { sessionReady } from "@/lib/auth-ready";
import { getSessionSnapshot } from "@lato/client/lib/supabase";
import { clearLegacyActingState } from "@/lib/legacyActing";
import { usePostHogIdentify } from "@/lib/usePostHogIdentify";

function AuthLayout() {
  // Identify the signed-in user to PostHog (authed surfaces only — public routes stay anonymous).
  usePostHogIdentify();
  const area = useMatches({
    select: (matches) =>
      matches.some((match) => match.routeId === "/_auth/admin")
        ? "administration"
        : matches.some((match) => match.routeId === "/_auth/_agents")
          ? "workspace"
          : null,
  });

  // `min-h-0` lets the inner scroll areas size correctly.
  return (
    <div className="flex h-full flex-col">
      <div className="min-h-0 flex-1">
        {area ? (
          <ApplicationShell administration={area === "administration"}>
            <Outlet />
          </ApplicationShell>
        ) : (
          <Outlet />
        )}
      </div>
    </div>
  );
}

export const Route = createFileRoute("/_auth")({
  component: AuthLayout,
  beforeLoad: async ({ location }) => {
    // Tabs from before direct admin access may still hold act-as state; it is never honored, so
    // drop it before any authed surface renders.
    clearLegacyActingState();
    await sessionReady;
    const session = getSessionSnapshot();
    if (!session) {
      throw redirect({
        to: "/signin",
        replace: true,
        search: { redirect: location.href },
      });
    }
    return { session };
  },
});
